// extracted by mini-css-extract-plugin
export default {"addMessage":"TodoList_addMessage__uajb+","todoList":"TodoList_todoList__yeIpl"};